import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=f2571b48&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=f2571b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2571b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2571b48')) {
      api.createRecord('f2571b48', component.options)
    } else {
      api.reload('f2571b48', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=f2571b48&scoped=true&", function () {
      api.rerender('f2571b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kGV9wU57yceE/JS/comp/DateRangeExt.vue"
export default component.exports